/**
 * Initializes the login error modal:
 * - Close and retry buttons dismiss the overlay.
 * - Clicking outside the modal (on overlay background) also dismisses it.
 *
 * Removes the entire .login-error-modal__overlay wrapper, which is a fixed overlay
 * that blocks page interaction if left in the DOM.
 */
export const initLoginErrorModal = () => {
  const overlay = document.getElementById('login-error-modal');
  if (!overlay) return;

  const closeModal = () => overlay.remove();

  document.getElementById('login-error-modal-close')?.addEventListener('click', closeModal);
  document.getElementById('login-error-modal-retry')?.addEventListener('click', closeModal);

  overlay.addEventListener('click', (event) => {
    if (event.target === overlay) closeModal();
  });
};
